<div class="company-alerts-panel-container container" fxLayout="row wrap"  fxLayoutAlign="center center"
     fxLayoutGap="15px">
  <mtn-simple-alert title="{{ 'COMPANY_ALERTS.EXPIRING.TITLE' | translate }}" color="purple"
                    [text]="' ' + ('COMPANY_ALERTS.EXPIRING.TEXT' | translate: { expirationDate: expirationDateString })"
                    *ngIf="isExpiring"  ></mtn-simple-alert>
                    <!-- (alertClick)="openUpdateLicenseWizard()" -->

  <mtn-simple-alert title="{{ 'COMPANY_ALERTS.EXPIRED.TITLE' | translate }}"
                    [text]="' ' + ('COMPANY_ALERTS.EXPIRED.TEXT' | translate: { expirationDate: expirationDateString })"
                    *ngIf="isExpired" icon="history" ></mtn-simple-alert>
                    <!-- (alertClick)="openUpdateLicenseWizard()" -->

  <mtn-simple-alert title="{{ 'COMPANY_ALERTS.SUSPENDED.TITLE' | translate }}" color="red"
                    [text]="' ' + ('COMPANY_ALERTS.SUSPENDED.TEXT' | translate: { suspendedDate: suspendedDateString })"
                    *ngIf="isSuspended" icon="exclamation-circle"></mtn-simple-alert>
</div>
